import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Layout from 'shared/layouts/Main'
import { Button, Form } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import InputWrapper from 'shared/components/InputWrapper'
import resImportRecipients from './resolvers/resImportRecipients'
import useInit from './hooks/useInit'
import useFocusError from 'shared/hooks/useFocusError'
import prepareSubmitForm from 'shared/utils/prepareSubmitForm'
import submitForm from './utils/submitForm'
import Footer from 'shared/components/Footer'
import BackButton from 'shared/components/BackButton'
import getBrandContent from 'utils/getBrandContent'
import downloadTemplate from './utils/downloadTemplate'
import { IonIcon } from '@ionic/react'
import { download } from 'ionicons/icons'

const submitRef = React.createRef<HTMLButtonElement>()

const ImportRecipients: React.FunctionComponent = () => {
  const [showOverlay, setShowOverlay] = useState<boolean>(true)
  const [dataLoaded, setDataLoaded] = useState<boolean>(false)

  const navigate = useNavigate()

  const {
    register,
    handleSubmit,
    setFocus,
    setError,
    formState: { errors },
  } = useForm({
    mode: 'all',
    resolver: resImportRecipients,
  })

  useInit({
    setDataLoaded,
    setShowOverlay,
  })

  useFocusError({
    errors,
    setFocus,
  })

  return (
    <Layout
      footerContent={<Footer />}
      brandContent={getBrandContent()}
      showOverlay={showOverlay}
      showCardHeader={true}
      headerInsert={<BackButton url={'/filters'} text='Filters' />}
      actionInsert={
        <>
          <Button
            onClick={(e) => {
              e.preventDefault()
              downloadTemplate({
                setShowOverlay,
              })
            }}
            variant='primary'
            className='me-3'
          >
            <IonIcon
              icon={download}
              className='ionicon'
              style={{ fontSize: '16px', marginBottom: '-3px' }}
            />
            Download Import Template
          </Button>
          <Button
            disabled={!dataLoaded}
            type='submit'
            name='save'
            className='btn-round btn-primary'
            onClick={() => {
              if (submitRef.current != null) {
                submitRef.current.click()
              }
            }}
          >
            Import
          </Button>
        </>
      }
    >
      <Form
        onSubmit={handleSubmit((data) =>
          prepareSubmitForm({
            submitForm,
            navigate,
            data: {
              ...data,
            },
            setShowOverlay,
            setError,
            id: undefined,
            name: 'Filter Values',
            //customMessage:
            //  'Import file successfully processed. Please, check error file if exists.',
            successNav: '/filters',
          }),
        )}
        id='main-form'
      >
        <InputWrapper label='File' name='file' errors={errors}>
          <Form.Control type='file' {...register('file')} />
        </InputWrapper>

        <Button type='submit' name='save' ref={submitRef} className='d-none'></Button>
      </Form>
    </Layout>
  )
}

export default ImportRecipients
